import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  details: {
    borderTop: `1px solid ${theme.palette.card.divider}`,
    display: 'flex',
    flexDirection: 'column',
    fontSize: '16px',
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    width: '100%',

    '& > *': {
      marginBottom: theme.spacing(1.5),
    },

    [theme.breakpoints.up('md')]: {
      alignItems: 'center',
      borderTop: '0 none',
      flexDirection: 'row',
      marginTop: theme.spacing(5),
      paddingTop: 0,

      '& > *': {
        marginBottom: 0,
        marginRight: theme.spacing(1),

        '&:last-child': {
          marginRight: 0,
        },
      },
    },
  },
}))

export default function DetailsContainer({ children }) {
  const classes = useStyles()

  return <div className={classes.details}>{children}</div>
}
